import { render, staticRenderFns } from "./AreaConfigList.vue?vue&type=template&id=380952e1&scoped=true&"
import script from "./AreaConfigList.vue?vue&type=script&lang=js&"
export * from "./AreaConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380952e1",
  null
  
)

export default component.exports